// tslint:disable max-line-length
import axios from 'axios';
import { getItem } from '../../utils/localStorage';
import { CreateDataByIndexedDB, GetAllDataByIndexedDB } from '../../indexed/index';
import { authMeRes } from '../../requests/notifications';
import axiosInstance from '../../helpers/interceptor';
import { userHotelDetails } from '../../helpers/handleBrandAndHotelData';

export const getUsers = async (text) => {
    const { data } = await axiosInstance.get(`${Env.API_URL}/customerClientUser/assignees/?page=1&pageSize=10&isActive=true&sort=userLastName%2CuserFirstName&name=${text}&&isClientApp=true`);
    return data;
};

export const getAssessments = async () => {
    const { selectedHotel } = userHotelDetails();
    let dataD: any = [];
    const OfflineData = await GetAllDataByIndexedDB(`${Env.API_URL}/customerAssessment/publishedDates/?page=1&sort=-insertDate&pageSize=6&hotelIds=${selectedHotel}&`, selectedHotel);
    if (OfflineData) {
        dataD = OfflineData;
    } else {
        const { data } = await axiosInstance.get(`${Env.API_URL}/customerAssessment/publishedDates/?page=1&sort=-insertDate&pageSize=6&hotelIds=${selectedHotel}&`);
        dataD = data;
        CreateDataByIndexedDB(`${Env.API_URL}/customerAssessment/publishedDates/?page=1&sort=-insertDate&pageSize=6&hotelIds=${selectedHotel}&`, data, selectedHotel);
    }

    return dataD;
};

export const getCustomScoreType = async () => {
    const { selectedHotel } = userHotelDetails();
    let dataD: any = [];
    const OfflineData = await GetAllDataByIndexedDB(`${Env.API_URL}/customer/hotel-reports-filter/${selectedHotel}/customScoreTypes?&`, selectedHotel);
    if (OfflineData) {
        dataD = OfflineData;
    } else {
        const { data } = await axiosInstance.get(`${Env.API_URL}/customer/hotel-reports-filter/${selectedHotel}/customScoreTypes?&`);
        dataD = data;
        CreateDataByIndexedDB(`${Env.API_URL}/customer/hotel-reports-filter/${selectedHotel}/customScoreTypes?&`, data, selectedHotel);
    }

    return dataD;
};

export const getFocusAreaOptions = async (selectedAssessmentId, selectedStandardType, selectedTemplateId, actionPlanId?: number) => {
    const { selectedHotel } = userHotelDetails();
    const { data } = await axiosInstance.get(`${Env.API_URL}/actionPlan/focusAreaOptions?&hotelId=${selectedHotel}&assessmentId=${selectedAssessmentId}&templateId=${selectedTemplateId}&standard=${selectedStandardType === 'LQA' ? 'LQA' : selectedStandardType}${actionPlanId ? '&actionPlanId=' + actionPlanId : ''}&isClientApp=true`);

    return data;
};

export const createActionPlan = async (payLoad) => {
    const userData = getItem('user');
    const { data } = await axios.post(`${Env.API_URL}/actionPlan/`, payLoad, {
        headers: {
            Authorization : `Bearer ${userData.accessToken}`,
        },
    });

    return data;
};
export const editActionPlan = async (payLoad) => {
    const response = await authMeRes();
    const { accessToken } = response.data;
    const { data } = await axios.put(`${Env.API_URL}/actionPlan/${payLoad.id}`, payLoad, {
        headers: {
            Authorization : `Bearer ${accessToken}`,
        },
    });

    return data;
};

export const updateActionPlanStatus = async (id, payLoad) => {
  const userData = getItem('user');
  const { data } = await axios.put(
    `${Env.API_URL}/actionPlan/updateActionPlanStatus/${id}`,
    payLoad,
    {
      headers: {
        Authorization: `Bearer ${userData.accessToken}`,
      },
    }
  );

  return data;
};

export const uploadActionPlanAttachment = async (actionPlanId, formData) => {
    const userData = getItem('user');
    const { data } = await axios.post(`${Env.API_URL}/actionPlan/${actionPlanId}/attachFile`, formData, {
        headers: {
            'content-type' : 'multipart/form-data',
            'Authorization' : `Bearer ${userData.accessToken}`,
        },
    });

    return data;
};
export const deleteActionPlanAttachment = async (actionPlanId, fileId, fileName) => {
    const userData = getItem('user');
    const { data } = await axios.delete(`${Env.API_URL}/actionPlan/${actionPlanId}/removeAttachment/${fileId}?fileName=${fileName}&isClientApp=true`, {
        headers: {
            Authorization : `Bearer ${userData.accessToken}`,
        },
    });
    return data;
};

export const getActionPlanById = async (id) => {
        const { data } = await axiosInstance.get(`${Env.API_URL}/actionPlan/${id}?`);
        return data;
};

export const getParentActionPlanInfo = async (id) => {
        const { data } = await axiosInstance.get(`${Env.API_URL}/actionPlan/parent/${id}?`);
        return data;
};
